var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolanaSolSeeklogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 643,
    height: 643,
    viewBox: "0 0 643 643",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187.281 330.743C189.714 328.311 193.014 326.946 196.454 326.946H513.851C519.633 326.946 522.527 333.937 518.437 338.024L455.72 400.691C453.287 403.123 449.987 404.489 446.547 404.489H129.15C123.368 404.489 120.474 397.497 124.564 393.41L187.281 330.743Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M187.281 96.6225C189.714 94.191 193.014 92.8252 196.454 92.8252H513.851C519.633 92.8252 522.527 99.8169 518.437 103.904L455.72 166.571C453.287 169.002 449.987 170.368 446.547 170.368H129.15C123.368 170.368 120.474 163.377 124.564 159.29L187.281 96.6225Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M455.72 212.937C453.287 210.506 449.987 209.14 446.547 209.14H129.15C123.368 209.14 120.474 216.132 124.564 220.218L187.281 282.886C189.714 285.317 193.014 286.683 196.454 286.683H513.851C519.633 286.683 522.527 279.691 518.437 275.604L455.72 212.937Z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 391.52,
    y1: 7.33416,
    x2: 171.854,
    y2: 428.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 391.52,
    y1: 7.33416,
    x2: 171.854,
    y2: 428.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 391.52,
    y1: 7.33416,
    x2: 171.854,
    y2: 428.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolanaSolSeeklogo);
export default __webpack_public_path__ + "static/media/solana-sol-seeklogo.a9366824902c05e9cf376a9f6b168122.svg";
export { ForwardRef as ReactComponent };